// ── NAV SCROLL BEHAVIOR ──
const nav = document.getElementById('pemi-nav');
if (nav) {
  window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 40);
  });
}

// ── HAMBURGER MENU ──
const hamburger = document.getElementById('pemi-hamburger');
const mobileNav = document.getElementById('pemi-mobile-nav');
if (hamburger && mobileNav) {
  hamburger.addEventListener('click', () => {
    mobileNav.classList.toggle('open');
  });
  document.addEventListener('click', (e) => {
    if (!hamburger.contains(e.target) && !mobileNav.contains(e.target)) {
      mobileNav.classList.remove('open');
    }
  });
}

// ── SCROLL REVEAL ANIMATIONS ──
const fadeObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const siblings = Array.from(entry.target.parentNode.children);
      const index = siblings.indexOf(entry.target);
      setTimeout(() => {
        entry.target.classList.add('visible');
      }, index * 80);
      fadeObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.08 });

document.querySelectorAll('.p-fade-up').forEach(el => fadeObserver.observe(el));

// ── QUIZ CHIPS (homepage) ──
document.querySelectorAll('.p-quiz-chip').forEach(chip => {
  chip.addEventListener('click', function() {
    this.classList.toggle('selected');
  });
});